import { PromoAnalyticsService } from '@analytics/feature';
import { NgOptimizedImage } from '@angular/common';
import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { BannerWithTabItem } from '@promo/const';
import { SdvorGenericLinkComponent } from '@sdvor/shared/ui';

@Component({
  selector: 'sd-banner-with-tab-item',
  host: {
    // Добавлено в задаче SPA-1799
    '[attr.ngSkipHydration]': 'true',
  },
  imports: [NgOptimizedImage, SdvorGenericLinkComponent],
  templateUrl: './banner-with-tab-item.component.html',
  styleUrls: ['./banner-with-tab-item.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class BannerWithTabItemComponent {
  @Input() banner: BannerWithTabItem;

  constructor(private promoAnalyticsService: PromoAnalyticsService) {}

  protected onBannerClick(banner: BannerWithTabItem): void {
    const { id, name } = banner;

    this.promoAnalyticsService.onClickBanner({
      id,
      name: name,
      position: 'main_page',
    });
  }
}
